import React from "react";
import {
  ReportFilterSection,
  SelectComponent,
} from "../../../../shared";
import {
  REPORT_FILTER_LABELS,
  REPORT_FILTER_STYLES,
  REPORT_FILTER_CLASSES,
} from "../../../../constants";

import {
  emptyString,
  storesConstants,
} from "../../../admin-screens/constants";

const DatePicker = (props) => {
  const {
    stores,
    spinner,
    allBrands,
    dateState,
    setDateState,
    selectedBrand,
    selectedLocation,
    setSelectedBrand,
    setSelectedLocation,
    getStoresAgainstBrandId,
  } = props;

  const isBrandsLoading = spinner(storesConstants.FETCH_ALL_BRANDS);
  const isStoresLoading = spinner(storesConstants.FETCH_BRAND_LOCATIONS);

  return (
    <div className="container-fluid pt-3">
      <div className="notification-form shadow card px-2 mb-3">
        <div className="card-body py-4">
          <h5>Campaign Metrics</h5>
          <hr />
          <ReportFilterSection
            dateState={dateState}
            setDateState={setDateState}
          >
            <SelectComponent
              value={selectedBrand}
              options={[
                {
                  value: emptyString,
                  name: REPORT_FILTER_LABELS.BRAND,
                },
                ...allBrands,
              ]}
              onChange={(e) => {
                setSelectedBrand(e);
                e.id && getStoresAgainstBrandId(e.id);
                setSelectedLocation([]);
              }}
              placeholder={REPORT_FILTER_LABELS.BRAND}
              styles={REPORT_FILTER_STYLES}
              className={REPORT_FILTER_CLASSES.SPACED_SELECT}
              isLoading={isBrandsLoading}
              isDisabled={isBrandsLoading}
            />
            <SelectComponent
              value={selectedLocation}
              options={[
                {
                  value: emptyString,
                  name: REPORT_FILTER_LABELS.STORE,
                },
                ...stores,
              ]}
              onChange={(e) => setSelectedLocation(e)}
              placeholder={REPORT_FILTER_LABELS.STORE}
              styles={REPORT_FILTER_STYLES}
              className={REPORT_FILTER_CLASSES.SELECT}
              isLoading={isStoresLoading}
              isDisabled={isStoresLoading}
            />
          </ReportFilterSection>
        </div>
      </div>
    </div>
  );
};

export default DatePicker;
